module.exports = __webpack_public_path__ + "static/gruenes_herz-898986f6c139adfda52c1d9841b12bdc.png";